import { CommonHeader } from "../Common/CommonHeader";

export default function EditorInChief() {
  return (
    <div>
      <CommonHeader title={"EDITOR-IN-CHIEF"} />
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h2 className="fw-bold">EDITOR-IN-CHIEF</h2>
            <p className="text-muted">
              <strong>Research Discourse:</strong> An International
              Peer-Reviewed Refereed Research Journal, ISSN 2277-2014 (Print)
            </p>
            <hr className="border-danger w-25" />
            <p>
              National Journal of Education is a Leading high quality open
              access & peer reviewed bi-annually published research journal. The
              aim of the journal is to provide platform for diversity of
              intellectual pursuit from all corners of the society for
              enrichment and enhancement of the group readers. The Journal
              welcomes and acknowledges high quality theoretical and empirical
              original research papers, case studies, review papers, literature
              reviews, book reviews, conceptual framework, analytical and
              simulation models, technical note from researchers, academicians,
              professional, practitioners and students from all over the world.
              The journal is being published bi-annually and in the bi-lingual
              language (English and Hindi). The Journal covers all the areas of
              Social Sciences and Humanities.
            </p>
            <p>
              <h6 className="m-0">Editor in Chief</h6>
              <h4 className="m-0">Dr. Girja Prasad Mishra</h4>
              Head, Department of Education
              <br />
              Post Graduate College, Patti, Pratapgarh (U.P.)
              <br />
              <span className="strong">EMAIL: njouedu@gmail.com</span>
              <br />
              <span className="strong">PHONE NUMBER: 8317065821</span>
            </p>
          </div>
          <div className="col-md-4 text-center">
            <img
              src="/assets/logo national journal of education.JPG"
              alt="Profile"
              className="profile-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
